module.exports = __webpack_public_path__ + "a6fd89546cf5b09aff8ad95d163bdb31.png";